<template>
  <div ref="el" class="stat-counter">
    <span class="num value">{{ display }}</span>
    <span class="num suffix">{{ suffix }}</span>
    <span class="label">{{ label }}</span>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'

const props = defineProps({
  value: { type: Number, required: true },
  suffix: { type: String, default: '' },
  label: { type: String, required: true },
  duration: { type: Number, default: 1800 }
})

const el = ref(null)
const display = ref(0)
let rafId = null
let observer = null

function runCount() {
  const start = performance.now()
  const step = now => {
    const t = Math.min((now - start) / props.duration, 1)
    const eased = 1 - Math.pow(1 - t, 3)
    display.value = Math.round(props.value * eased)
    if (t < 1) rafId = requestAnimationFrame(step)
  }
  rafId = requestAnimationFrame(step)
}

onMounted(() => {
  observer = new IntersectionObserver(
    entries => {
      if (entries[0].isIntersecting) {
        runCount()
        observer.disconnect()
      }
    },
    { threshold: 0.4 }
  )
  observer.observe(el.value)
})

onBeforeUnmount(() => {
  if (observer) observer.disconnect()
  if (rafId) cancelAnimationFrame(rafId)
})
</script>

<style scoped>
.stat-counter {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 8px 12px;
}

.value {
  font-size: 52px;
  font-weight: 700;
  line-height: 1;
  background: linear-gradient(135deg, #ffffff, var(--hl-cyan));
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.suffix {
  font-size: 30px;
  font-weight: 600;
  line-height: 1;
  background: linear-gradient(135deg, #ffffff, var(--hl-cyan));
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.label {
  margin-top: 10px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.65);
}

@media (max-width: 768px) {
  .value {
    font-size: 38px;
  }
  .suffix {
    font-size: 24px;
  }
}
</style>
